import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const DialogTitle = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.DialogTitleProps,
  "as" | "className"
>): ReactElement => (
  <Headless.DialogTitle
    {...props}
    className={clsx(
      className,
      "text-balance text-lg/6 font-semibold text-zinc-950 sm:text-base/6 dark:text-white",
    )}
  />
);
